import { useMemo } from 'react';
import { WHITE_LABEL_ORGS } from '@constants/white-label';
import deepsetFavicon from '/favicon.ico';
import { useCurrentRoute } from './useCurrentRoute';

interface UseWhiteLabelProps {
  orgId?: string;
}

const DEEPSET_DEFAULT = {
  favicon: deepsetFavicon,
  title: 'deepset AI platform',
};

export const useDocumentBranding = ({ orgId }: UseWhiteLabelProps) => {
  const {
    header: { title: currentRouteTitle },
  } = useCurrentRoute();

  const whiteLabelConfig = useMemo(() => {
    if (!orgId) return null;
    return WHITE_LABEL_ORGS[orgId] || null;
  }, [orgId]);

  const updateDocumentMetadata = () => {
    const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    const titleParts: string[] = [];

    if (favicon) favicon.href = whiteLabelConfig?.favicon || DEEPSET_DEFAULT.favicon;
    if (currentRouteTitle) titleParts.push(currentRouteTitle);

    titleParts.push(whiteLabelConfig?.title || DEEPSET_DEFAULT.title);
    document.title = titleParts.filter(Boolean).join(' - ');
  };

  return {
    isWhiteLabeled: !!whiteLabelConfig,
    whiteLabelAssets: whiteLabelConfig,
    updateDocumentMetadata,
  };
};
